export default {
  Admin: "Admin",
  Development: "Development",
  Servicios: "Servicios",
  Soporte: "Soporte",
  GerenteDeSoporte: "Gerente de Soporte",
  SoporteVentas: "Soporte Ventas",
  SuperUsuario: "Super Usuario",
  Finanzas: "Finanzas",
  Legal: "Legal",
  Asistente: "Asistente",
  EjecutivoDeVentas: "Ejecutivo de Ventas",
  Proyectos: "Proyectos",
  Instalador: "Instalador",
  EncargadaCompras: "Encargada Compras",
  Desarrollador: "Desarrollador",
  TI: "TI",
  TITécnico: "TI Técnico",
  AnalistaDeMarketing: "Analista de Marketing",
  GerenteRRHH: "Gerente RRHH",
  SupervisorDeTécnicos: "Supervisor de Técnicos",
  CuentasPorCobrar: "Cuentas por Cobrar",
  Marketing: "Marketing",
  TécnicoDeTaller: "Técnico de taller",
  AuxiliarSoporteTécnico: "Auxiliar Soporte Técnico",
  GerenciaGeneral: "Gerencia General",
  SoporteServicios: "Soporte Servicios",
  ServicioAlCliente: "Servicio al Cliente",
  CoordinadorIso: "Coordinador Iso",
  GerenteDeCalidad: "Gerente de Calidad",
  TecnicoTaller: "Tecnico Taller",
  DirectorDeProyectos: "Director de proyectos",
  CoordinadorDeSoporte: "Coordinador de soporte",
  DirectorAdministrativo: "Director administrativo",
  Pruebas: "Pruebas",
  CoornidadorDeServicioAlCliente: "Coornidador de servicio al cliente",
  EncargadoDesarrolloDeAplicaciones: "Encargado Desarrollo de Aplicaciones",
  CorteYReconexión: "Encargado Desarrollo de Aplicaciones",
  CallCenter: "CallCenter",
  CEO: "CEO",
  Message: "Message",
  ChangeCompany: "ChangeCompany",
  SupervisorDeSoporteDeVentas: "Supervisor de soporte de ventas",
  SupervisorDeVentas: "Supervisor de ventas",
  AdministradorDeAuthorizador: "Administrador de Authorizador",
  EnvioNotificacionCliente: "Envio notificacion clientes",
  EncuestaEmpleados: "Encuestas de Empleados",
  EncuestaClientes: "Encuestas de Clientes",
  ReasignaciondeClientes: "Funcion de Reasignacion de Clientes",
  Nomina_RH: "Nomina recursos humanos",
  Nomina_Finanzas: "Nomina finanzas",
  Nomina_CEO: "Nomina CEO",
  ContactoEmergente: "Contacto Emergente"
};
